var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutYourCompanyBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 8.16667C18.6667 7.0817 18.6667 6.53922 18.5474 6.09413C18.2238 4.88631 17.2804 3.94289 16.0725 3.61926C15.6275 3.5 15.085 3.5 14 3.5C12.915 3.5 12.3726 3.5 11.9275 3.61926C10.7197 3.94289 9.77624 4.88631 9.4526 6.09413C9.33334 6.53922 9.33334 7.0817 9.33334 8.16667M6.06668 24.5H21.9333C23.2401 24.5 23.8935 24.5 24.3927 24.2457C24.8317 24.022 25.1887 23.665 25.4124 23.226C25.6667 22.7269 25.6667 22.0735 25.6667 20.7667V11.9C25.6667 10.5932 25.6667 9.93982 25.4124 9.44069C25.1887 9.00164 24.8317 8.64469 24.3927 8.42098C23.8935 8.16667 23.2401 8.16667 21.9333 8.16667H6.06668C4.75989 8.16667 4.10649 8.16667 3.60737 8.42098C3.16832 8.64469 2.81137 9.00164 2.58766 9.44069C2.33334 9.93982 2.33334 10.5932 2.33334 11.9V20.7667C2.33334 22.0735 2.33334 22.7269 2.58766 23.226C2.81137 23.665 3.16832 24.022 3.60737 24.2457C4.10649 24.5 4.75989 24.5 6.06668 24.5Z",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutYourCompanyBag);
export default __webpack_public_path__ + "static/media/aboutYourCompanyBag.657d371e792e8c70d50c9aaa9bd661d8.svg";
export { ForwardRef as ReactComponent };